import {dataLayerPush} from "JQueryScripts/data-layer-handlers/data-layer-push";
import {obtainPlan} from "JQueryScripts/data-layer-handlers/plan-obtainer";

export const buttonTariffPlanHandler = async (category) => {
    const variant = $('.pricing-tables__tabs .tabs__item--active').data('id') === 'tabs-annual-payment' ?
        'yearly' :
        'monthly';

    const item = await obtainPlan(
        category,
        category !== 'basic' ? variant : null,
        'add_to_cart'
    );

    item.currency = item.ecommerce.currency;

    delete item.ecommerce.currency;
    delete item.ecommerce.value;

    dataLayerPush(item);

    return true;
};